module.exports = __webpack_public_path__ + "static/media/YF89_4.8b97b981.jpg";